export const MAILING_LISTS = {
  NEWSLETTER: '522f54d4-4bb2-11f1-967c-113d3ed6c688',
  CONTACTS: '129771c8-cced-11f1-94ce-ffc28d665f6e',
} as const;

export type MailingListId = typeof MAILING_LISTS[keyof typeof MAILING_LISTS];
